/* eslint-disable no-param-reassign */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listingType: "for-rent"
};

const listingTypeSlice = createSlice({
  name: "listingType",
  initialState,
  reducers: {
    setForSale(state) {
      state.listingType = "for-sale";
    },
    setForRent(state) {
      state.listingType = "for-rent";
    }
  }
});

export const { setForRent, setForSale } = listingTypeSlice.actions;
export default listingTypeSlice.reducer;
